import ModuleFeaturedContent from './ModuleFeaturedContent';

export default ModuleFeaturedContent;
export * from './ModuleFeaturedContent';
